module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo-upload"
  }, [_c('input', {
    ref: "input",
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "multiple": ""
    },
    on: {
      "change": function($event) {
        _vm.onChange()
      }
    }
  }), _vm._v(" "), _vm._l((_vm.value), function(file, index) {
    return _c('div', {
      staticClass: "photo"
    }, [_c('img', {
      attrs: {
        "src": file.data,
        "alt": file.name
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "remove",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(index)
        }
      }
    }, [_vm._v("x")])])
  }), _vm._v(" "), _c('a', {
    staticClass: "add",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.add($event)
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da22692","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/photo-upload.vue
// module id = 107
// module chunks = 0 1